import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getLoginPathForPortal, resolvePortalForGuard } from '../utils/loginPortal';

interface RequireMembershipProps {
  children: React.ReactNode;
  redirectTo?: string;
  schoolId?: string;
}

export const RequireMembership: React.FC<RequireMembershipProps> = ({
  children,
  redirectTo,
  schoolId,
}) => {
  const { user } = useAuth();
  const location = useLocation();

  const hasMembership = user?.memberships?.some((membership) => {
    if (schoolId) {
      return membership.school_id === schoolId;
    }
    return !!membership.school_id;
  });

  if (!hasMembership) {
    const loginPath =
      redirectTo ?? getLoginPathForPortal(resolvePortalForGuard(location.pathname));
    return <Navigate to={loginPath} replace />;
  }

  return <>{children}</>;
};

